import { atom } from "jotai";
import type { PaymentPeriod } from "./components/QuoteCards/types";
import { ANNUAL } from "./constants/constants";
import type { QuoteComparisonPageFeatureProps, WithMetadata } from "./pages";
import type { Locale } from "./types";
import type { RewardBannerProps } from "./components/RewardBanner";

export const sliderStateAtom = atom<boolean>(false);

export const paymentToggleAtom = atom<PaymentPeriod>(ANNUAL);

export const experimentsAtom = atom<Map<string, string>>(new Map());

export const localeAtom = atom<Locale>("en-GB");

export type Tokens = {
  authenticityToken: string;
  journeyToken: string;
};

export const tokensAtom = atom<Tokens>({
  authenticityToken: "",
  journeyToken: "",
});

export const quoteComparisonPageAtom = atom<QuoteComparisonPageFeatureProps[]>(
  [],
);

export const environmentAtom = atom<{
  site: string;
  journeyId: string;
  vertical?: string;
  affclie?: string;
}>({ site: "", journeyId: "" });

export const questionnaireFormUrlAtom = atom<string | undefined>("");

export const redirectAtom = atom<string | undefined>(undefined);

export const rewardBannerAtom = atom<
  WithMetadata<RewardBannerProps> | undefined
>();

export { seeMoreCoversStateAtom } from "./features/questionnaire/state/seeMoreCoversStateAtom";

export const personalisedCoverAccordionAtom = atom<string | undefined>(
  undefined,
);

export const apiErrorAtom = atom<string | null>(null);
